import DownloadIcon from '@ui-components-3/icons/lib/regular/Download'
import classNames from '@ui-components-3/ui/lib/utils/classNames'
import Loading from '@ui-components-3/ui/lib/components/Loading'

type ReportCardProps = {
  title: string
  onClick: () => void
  isLoading?: boolean
}

const ReportCard = ({ title, onClick, isLoading }: ReportCardProps) => {
  return (
    <div
      className={classNames(
        'rounded-xl bg-white shadow-[0px_8px_16px_0px_rgba(27,99,162,0.08)] gap-2 p-6 flex items-center justify-between text-neutral-800 typography-body font-medium cursor-pointer transition-transform hover:scale-[1.01]',
        !!isLoading && 'pointer-events-none',
      )}
      onClick={isLoading ? undefined : onClick}
    >
      {title}
      <span className="shrink-0 w-10 h-10 rounded-full flex items-center justify-center text-neutral-500 bg-neutral-200">
        {!isLoading ? (
          <DownloadIcon aria-hidden="true" className="w-5 h-5" />
        ) : (
          <Loading shown className="text-primary-600 [&_svg]:w-5 [&_svg]:h-5" />
        )}
      </span>
    </div>
  )
}

export default ReportCard
